export default class ClientError extends Error {
  constructor(readonly originalError: Error) {
    super(`Client Error: ${originalError.message}`);
  }
}
